import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Row, Button, Modal, Space } from "antd";
import { useAuthDispatch } from "../provider/AuthProvider";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as Common from "../commons/common";
import * as String from "../commons/string";
import * as Utils from "../utils/utils";

import chevronRight from "../assets/images/chevronRight.svg";
import PageContainer from "../layout/PageContainer";
import styles from "./Settings.module.css";

const sharedAnim = {
    whileTap: {
        x: 10,
        scale: 0.95,
    },
    exit: {},
};

const settingPageRoutes = [
    {
        name: "차량 등록하기",
        route: Common.PAGE_REGISTER_CAR,
    },
    {
        name: "내 차량 관리",
        route: Common.PAGE_MANAGE_CAR,
    },
    {
        name: "비밀번호 재설정",
        route: Common.PAGE_CHANGE_PASSWORD,
    },
    {
        name: "사업자 정보",
        route: Common.PAGE_COMPANY_INFO,
    },
];

type TypeModalSetting = {
    contents: string;
    confirm?: () => void;
};

function Settings() {
    const navigate = useNavigate();
    const dispatch = useAuthDispatch();
    const alert = useAlert();

    const [modalSettingInfo, setModalSettingInfo] = useState<TypeModalSetting>();
    const [openModalSetting, setOpenModalSetting] = useState(false);

    useEffect(() => {
        openModalSetting ? Utils.addModalStack() : Utils.popModalStack();
    }, [openModalSetting]);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);

        return () => {
            Utils.offEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);
        };
    }, []);

    const handleCloseAllModal = () => {
        setOpenModalSetting(false);
    };

    const handleLogout = () => {
        dispatch && dispatch({ type: "LOGOUT" });
        alert.setAlert(AlertType.SUCCESS, "로그아웃", "로그아웃 하였습니다.");
        navigate(Common.PAGE_LOGIN, { replace: true });
    };

    const handleDelete = () => {
        navigate(Common.PAGE_WITHDRAW_MEMBER);
    };

    return (
        <PageContainer pageBackground={`#fff`} contentPadding={16}>
            <Row align="middle" justify="center">
                <div className="container">
                    <Space align="end" size={24} className={styles.contentContainer}>
                        {settingPageRoutes.map((item) => (
                            <motion.div
                                key={item.route}
                                variants={sharedAnim}
                                whileTap="whileTap"
                                exit="exit"
                                onClick={() => navigate(item.route)}
                                className={styles.cardBtn}
                            >
                                <span className={styles.title}>{item.name}</span>
                                <img height="14px" src={chevronRight} alt="right arrow" />
                            </motion.div>
                        ))}

                        <motion.div
                            className={styles.cardBtn}
                            variants={sharedAnim}
                            whileTap="whileTap"
                            exit="exit"
                            onClick={() => {
                                setOpenModalSetting(true);
                                setModalSettingInfo({ contents: "로그아웃 하시겠습니까?", confirm: handleLogout });
                            }}
                        >
                            <span className={styles.title}>{String.logout}</span>
                        </motion.div>

                        <Button
                            type="text"
                            className={styles.deleteAccount}
                            onClick={() => {
                                setOpenModalSetting(true);
                                setModalSettingInfo({
                                    contents: "계정을 탈퇴하면 등록된 차량 정보가 사라집니다. 정말 탈퇴하시겠습니까?",
                                    confirm: handleDelete,
                                });
                            }}
                        >
                            {String.withdraw}
                        </Button>
                    </Space>
                    <Modal
                        className="confirmModal"
                        centered
                        key="modalSetting"
                        open={openModalSetting}
                        closable={false}
                        onCancel={() => setOpenModalSetting(false)}
                        footer={[
                            <Button block key="back" onClick={() => setOpenModalSetting(false)}>
                                {String.cancel}
                            </Button>,
                            <Button
                                block
                                danger
                                key="confirm"
                                onClick={() => {
                                    setOpenModalSetting(false);
                                    modalSettingInfo?.confirm && modalSettingInfo?.confirm();
                                }}
                            >
                                {String.confirm}
                            </Button>,
                        ]}
                    >
                        <Row justify={"center"} align={"middle"}>
                            {modalSettingInfo?.contents}
                        </Row>
                    </Modal>
                </div>
            </Row>
        </PageContainer>
    );
}

export default Settings;
